import { Box, TextField, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import PopupForm from "../../Components/PopupForm";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CustomeSelectField from "../../Components/CustomeSelectField";
import CustomTextField from "../../Components/CustomTextField";
import axios from "../../assets/js/AxiosInterceptors";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import host from "../../assets/js/Host";
import { FilePicker } from "evergreen-ui";
import { setGlobalLoading } from "../../reduxStore/SettingsReducer";

const cookies = new Cookies();
const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  return (
    <Box className="Container-fluid">
      <Box className="row pt-4">
        <Box className="col-12 col-sm-12 col-md-10 m-auto">
          <Box
            id="dailog"
            sx={{
              marginTop: "15px",
              backgroundColor: "#fff",
              boxShadow: "0 0 7px -2px rgba(0,0,0,0.3)",
              height: "55px !important",
              "& .evergreen-file-picker-text-input": {
                border: "none !important",
                height: "55px",
              },
              "& button": {
                border: "none !important",
                height: "55px !important",
                border:'none !important',
                outline:'none !important',
                backgroundColor:'#1e6a99',
                color:'#fff',
                fontWeight:600,
                fontSize:18
              },
              "& button:hover": {
                backgroundColor:'#1e6a99a0 !important',
                color:'#fff',
              },
              "& .evergreen-file-picker-root":{
                width:'100%',
                padding:'0 !important'
              }
            }}
          >
            {/* <div id="dialog_title">File </div> */}
            <div style={{ width: "100%", textAlign: "center" }}>
              <FilePicker
                multiple
                width={250}
                onChange={(files) => {
                  console.log('sadasdasdasdsad',files)
                  props?.setFiles(files);
                  props?.setFile(files?.length);
                }}
                placeholder="Select the file here!"
              />
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function AttachFile2(props) {
  const [t] = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [spin, setSpin] = useState(false);
  const myRef = React.useRef();
  const [verified, setVerified] = useState("");
  const [check, setCheck] = useState("login");
  const [file, setFile] = useState("");
  const [files, setFiles] = useState("");
  const dispatch=useDispatch()

  const submit = async () => {
    setLoading(true);
    setSpin(true);
    dispatch(setGlobalLoading(true))
    var headers = {
      jwt: cookies.get("token"),
    };
    let formData = new FormData();
    for (let i = 0; i < 6; i++) {
      formData.append("files", files[i]);
    }

    axios({
      url: host + `tasks/task_files/${props.id}`,
      method: "POST",
      headers: headers,
      data: formData,
    })
      .then((response) => {
    dispatch(setGlobalLoading(false))

        if (response.data.status === false) {
          toast.error(response.data.data.text);
          setLoading(false);
          setSpin(false);
        } else if (response.data.status === true) {
          toast.success("Info updated successfully");
          setLoading(false);
          setSpin(false);
          props?.setAddForm(false)
          const { onRefTask } = props.onRefTask;
          onRefTask();
          //  console.log('data',props.fun);
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        setLoading(false);
        setSpin(false);
    dispatch(setGlobalLoading(false))

      });
  };

  useEffect(() => {}, [props?.addForm]);

  return (
    <PopupForm
      open={props.addForm}
      setOpen={props.setAddForm}
      title={"Attach File"}
      content={
        <RenderContent
          verified={verified}
          setVerified={setVerified}
          check={check}
          setCheck={setCheck}
          file={file}
          setFile={setFile}
          files={files}
          setFiles={setFiles}
          loading={loading}
          setLoading={setLoading}
          open={props.addForm}
          setOpen={props.setAddForm}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={submit}
        />
      }
    />
  );
}
